<template>
  <div class="container general-section invoice-section" v-if="loaded">

    <div class="row">
      <div class="col-5">
        <h1>
          <font-awesome-icon icon="receipt"/>
          Faktura {{ dayMonth(invoice.created_at) }}
        </h1>
      </div>
      <div class="col-7 mt-1">
        <router-link :to="{name: 'earnings'}" class="btn btn-outline-dark">
          <font-awesome-icon icon="long-arrow-alt-left"/>
          Tillbaka till ersättning
        </router-link>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">
        Fakturainformation
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-7">

            <div class="alert alert-info">
              <small>
                Allt ni behöver göra är att ställa ut en faktura med den uträknade totalsumman ovan, tillsamans med fakturauppgifterna i högra hörnet. Maila därefter fakturan till <a href="mailto:affiliate_faktura@tecknael.se">affiliate_faktura@tecknael.se</a> glömt inte att nämna ert företagsnman som refferens. Fakturan kommer att attesteras: <b>{{ dayMonth(invoice.due_date)}}</b> förutsatt att fakturan mottagits i tid.
              </small>
            </div>

            <div class="invoice-sum">
              <div class="invoice-sum-label">Fakturasumma</div>
              <div class="invoice-sum-value">
                {{ invoice.total_sum_without_tax }}
                <span>
                  kr
                </span>
              </div>
              <div class="invoice-sum-hint">
                ex. moms
              </div>
            </div>

            <value-with-label label="Faktura datum">
              {{ dayMonth(invoice.created_at) }}
            </value-with-label>

            <value-with-label label="Faktura period">
              {{ dayMonth(invoice.from) }} - {{ dayMonth(invoice.to) }}
            </value-with-label>

            <value-with-label label="Betalningsdatum">
              {{ dayMonth(invoice.due_date) }}
            </value-with-label>

          </div>
          <div class="col-5">
            <div class="billing-data">

              <value-with-label label="Bolagsnamn">
                TecknaEl Sverige AB
              </value-with-label>

              <value-with-label label="Org.nr">
                559202-5489
              </value-with-label>

              <value-with-label label="Adress">
                Källstorpsvägen 8
              </value-with-label>

              <value-with-label label="Postnummer">
                46157
              </value-with-label>

              <value-with-label label="Ort">
                Trollhättan
              </value-with-label>

              <value-with-label label="Referens">
                {{ affiliate.name }}
              </value-with-label>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        Ersättning
      </div>

      <div class="pb-3">
        <search-earnings :earnings="searchEarnings" />

        <order-earnings :earnings="orderEarnings" />

        <pagination :pagination="pagination" :next="next" />
      </div>
    </div>

  </div>
</template>

<script>

  import {createNamespacedHelpers, mapState} from "vuex"
  import DateMixin from "../../../app/mixins/helpers/DateMixin"
  import SearchEarnings from "./Partials/Search"
  import Pagination from "../../Partials/Pagination"
  import ValueWithLabel from "../../Partials/Controls/ValueWithLabel"
  import OrderEarnings from "./Partials/Order"

  const { mapState: msEarnings } = createNamespacedHelpers('earnings')
  const { mapState: msInvoice } = createNamespacedHelpers('earnings/invoices/invoice')

  export default {
    name: "Invoice",
    components: {OrderEarnings, ValueWithLabel, Pagination, SearchEarnings},
    mixins: [
      DateMixin
    ],
    computed: {
      ...mapState({
        affiliate: state => state.auth.affiliate,
      }),
      ...msInvoice({
        invoice: state => state.data,
        loaded: state => state.loaded,
      }),
      ...msEarnings({
        earnings: state => state.collection,
        pagination: state => state.pagination,
      }),
      searchEarnings() {
        return this.earnings.filter(earning => earning.earnings_mode === 'search')
      },
      orderEarnings() {
        return this.earnings.filter(earning => earning.earnings_mode === 'order')
      }
    },
    async mounted() {
      await this.$store.dispatch(
        'earnings/invoices/invoice/fetch',
        this.$router.currentRoute.params.uuid
      )

      await this.fetchEarnings()
    },
    destroyed(){
      this.$store.commit('earnings/invoices/invoice/truncate')
      this.$store.commit('earnings/truncate')
    },
    methods: {
      async fetchEarnings(page = 1) {
        let input = {
          page,
          filter: {
            invoice_uuid: this.invoice.uuid
          }
        }

        return this.$store.dispatch('earnings/fetch', input)
      },
      next() {
        return this.fetchEarnings(this.pagination.current_page + 1)
      },
    },
    metaInfo() {
      return {
        title: `Faktura ${this.dayMonth(this.invoice.created_at)}`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Earnings/Invoice.vue